// Single source of truth for the "Where We Work" section (WhereWeWork.vue).
// These domains are distilled from the case studies in caseStudies.ts — add or
// edit an industry here and the landing section updates automatically.

export interface Industry {
  name: string;
  description: string;
}

export const industries: Industry[] = [
  {
    name: 'Real Estate &amp; PropTech',
    description:
      'Listing platforms, marketplaces and management tools that move property businesses online — built to scale with real inventory.',
  },
  {
    name: 'FinTech &amp; Insurance',
    description:
      'Policy tracking, accounting and payment-driven products where accuracy, security and trust are non-negotiable.',
  },
  {
    name: 'AI &amp; Automation',
    description:
      'Intelligent tooling and assistants that turn manual workflows into automated ones and surface insight from data.',
  },
  {
    name: 'SaaS Platforms',
    description:
      'Multi-tenant products with dashboards, billing and roles — architected to grow from first user to enterprise.',
  },
  {
    name: 'Marketing Technology',
    description:
      'Lead generation, analytics and growth platforms that help teams reach the right people and measure what works.',
  },
  {
    name: 'Digital Identity &amp; Networking',
    description:
      'Connected experiences and digital profiles that make sharing, networking and identity effortless.',
  },
];
